import { render, staticRenderFns } from "./materialApplyQuota.vue?vue&type=template&id=482fc4aa&scoped=true&"
import script from "./materialApplyQuota.vue?vue&type=script&lang=js&"
export * from "./materialApplyQuota.vue?vue&type=script&lang=js&"
import style0 from "./materialApplyQuota.vue?vue&type=style&index=0&id=482fc4aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fc4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482fc4aa')) {
      api.createRecord('482fc4aa', component.options)
    } else {
      api.reload('482fc4aa', component.options)
    }
    module.hot.accept("./materialApplyQuota.vue?vue&type=template&id=482fc4aa&scoped=true&", function () {
      api.rerender('482fc4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/materialApplyQuota.vue"
export default component.exports